import * as i0 from "@angular/core";
var DateService = /** @class */ (function () {
    function DateService() {
        this.checkMonth = [
            {
                number: 1,
                name: 'ม.ค.'
            },
            {
                number: 2,
                name: 'ก.พ.'
            },
            {
                number: 3,
                name: 'มี.ค.'
            },
            {
                number: 4,
                name: 'เม.ย.'
            },
            {
                number: 5,
                name: 'พ.ค.'
            },
            {
                number: 6,
                name: 'มิ.ย.'
            },
            {
                number: 7,
                name: 'ก.ค.'
            },
            {
                number: 8,
                name: 'ส.ค.'
            },
            {
                number: 9,
                name: 'ก.ย.'
            },
            {
                number: 10,
                name: 'ต.ค.'
            },
            {
                number: 11,
                name: 'พ.ย.'
            },
            {
                number: 12,
                name: 'ธ.ค.'
            }
        ];
        this.checkMonthFullTh = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
        this.checkMonth_en = [
            {
                number: 1,
                name: 'Jan'
            },
            {
                number: 2,
                name: 'Feb'
            },
            {
                number: 3,
                name: 'Mar'
            },
            {
                number: 4,
                name: 'Apr'
            },
            {
                number: 5,
                name: 'May'
            },
            {
                number: 6,
                name: 'Jun'
            },
            {
                number: 7,
                name: 'Jul'
            },
            {
                number: 8,
                name: 'Aug'
            },
            {
                number: 9,
                name: 'Sep'
            },
            {
                number: 10,
                name: 'Oct'
            },
            {
                number: 11,
                name: 'Nov'
            },
            {
                number: 12,
                name: 'Dec'
            }
        ];
        this.checkMonthFullEn = [
            {
                number: 1,
                name: 'January'
            },
            {
                number: 2,
                name: 'February'
            },
            {
                number: 3,
                name: 'March'
            },
            {
                number: 4,
                name: 'April'
            },
            {
                number: 5,
                name: 'May'
            },
            {
                number: 6,
                name: 'June'
            },
            {
                number: 7,
                name: 'July'
            },
            {
                number: 8,
                name: 'August'
            },
            {
                number: 9,
                name: 'September'
            },
            {
                number: 10,
                name: 'October'
            },
            {
                number: 11,
                name: 'November'
            },
            {
                number: 12,
                name: 'December'
            }
        ];
    }
    DateService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    DateService.prototype.changeFormatDate_2 = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_2 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear();
            var monthTh = this.checkMonth_en.filter(function (m) { return m['number'] === month_2; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    DateService.prototype.changeFormatDateFullTh = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_3 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonthFullTh.filter(function (m) { return m['number'] === month_3; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    DateService.prototype.changeFormatDateFullEn = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_4 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear();
            var monthTh = this.checkMonthFullEn.filter(function (m) { return m['number'] === month_4; })[0];
            return monthTh['name'] + ' ' + day + ', ' + year;
        }
    };
    DateService.ngInjectableDef = i0.defineInjectable({ factory: function DateService_Factory() { return new DateService(); }, token: DateService, providedIn: "root" });
    return DateService;
}());
export { DateService };
